import { IInteractiveModOpen, modTypes } from "@blings/blings-player";
import { ModsPanelCompProps } from "../../ModsPanel";
import { DynamicValueMod, DynamicValueModTypes } from "../../DynamicValueMod";
import { AddInteractiveHOC } from "./InteractiveFormHOC";
import { Col, Input, Row } from "antd";
import MainCTAButton from "../../../MainCTA/MainCTAButton";
import { useInteractiveCtaNameAutofill } from "./useInteractiveCtaNameAutofill";
import { sharedInputAllowClear } from "../../../antd-extensions/selectClearIcon";

function renderActionForm(props: ModsPanelCompProps<IInteractiveModOpen>) {
  return (
    <>
      <Row style={{ width: "100%" }}>
        <Col style={{ width: "100%" }}>
          <span style={{ color: "#6E7079", lineHeight: "22px" }}>
            Name this button (Required for analytics)
          </span>
          <Input
            style={{ width: "100%" }}
            id="connector-cta-name"
            value={props.change.ctaName}
            // eslint-disable-next-line no-template-curly-in-string
            placeholder="Name this button"
            onChange={(e) =>
              props.onChange(props.index, ["ctaName"], [e.target.value])
            }
            allowClear={sharedInputAllowClear}
          />
        </Col>
      </Row>
      <DynamicValueMod
        change={props.change}
        onChange={(index, keys, values) => {
          return props.onChange(
            index,
            (keys as Array<keyof IInteractiveModOpen>).concat("type"),
            values.concat(modTypes.interactiveOpen)
          );
        }}
        index={props.index}
        modId={props.modId}
        type={DynamicValueModTypes.url}
      />
      <MainCTAButton
        change={props.change}
        onChange={props.onChange}
        index={props.index}
      />
    </>
  );
}

export function AddInteractiveOpenForm(
  props: ModsPanelCompProps<IInteractiveModOpen>
) {
  useInteractiveCtaNameAutofill(props);
  return (
    <AddInteractiveHOC<IInteractiveModOpen>
      {...props}
      renderSpecificInteractive={renderActionForm}
    />
  );
}
